export default {
    name: "CallApi",
    title: "Call Web API",
    icon: "mdi-web",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            api: null,
            method: "GET",
            params: [],
            output: "field",
            childAction1: [],
            childAction2: []
        };
    },
};